import React from 'react';

export default props => {
    return (
        <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="check.circular">
                    <g id="Group-4">
                        <g id="Group-3-Copy-3">
                            <rect id="Rectangle" fill={props.background || '#0073FF'} x="0" y="0" width="28" height="28" rx="14"></rect>
                            <polyline id="Page-1-Copy" stroke={props.color || '#fff'} strokeWidth="2" transform="translate(14.000000, 14.500000) rotate(-270.000000) translate(-14.000000, -14.500000) " points="9.5 7.5 18.5 16.3223332 13.2781982 21.5"></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/images/CheckmarkCircle.js